export default "__VITE_ASSET__4caf14cf__"